module.exports = __webpack_public_path__ + "img/icon_count.202e31f4.svg";